import React, { useEffect, useState } from 'react'

// components
import NFTActivityInfoSection from 'components/pages/BrowseNFT/MainSection/NFTActivityInfoSection'

// utilies
import { compareDate } from 'utils/helpers'

// resources
import PlusIcon from 'assets/icons/plus-icon-8x8.svg?component'
import MinusIcon from 'assets/icons/minus-icon-8x8.svg?component'

// styles
import styles from './index.module.scss'

// api
import activityAPI from 'apis/activity'

const NFTHistorySection = props => {
  const { mintAddress } = props
  const [showDetails, setShowDetails] = useState(false)
  const [activityList, setActivityList] = useState([])
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    activityAPI.getNFTActivity(mintAddress).then(
      response => {
        let dateSorted = response.sort(compareDate)
        setActivityList(dateSorted)
        setIsLoaded(true)
      },
      error => {}
    )
  }, [mintAddress])

  return (
    <div className="w-full">
      <div className="w-full flex justify-between" onClick={() => setShowDetails(!showDetails)}>
        <div className={styles.details}>Activity</div>
        <div>{showDetails ? <MinusIcon /> : <PlusIcon />}</div>
      </div>

      {showDetails &&
        (activityList.length > 0 ? (
          <NFTActivityInfoSection activityList={activityList} />
        ) : isLoaded ? (
          <div className={styles.noCategory}>No transaction history detected for this artwork.</div>
        ) : (
          <></>
        ))}

      <div className={styles.descBorder} />
    </div>
  )
}

export default NFTHistorySection
